import {useEffect, useCallback} from 'react';
import {t} from "i18next";
import {useApi} from "../../api/useApi";

export const useYandexAuth = ({clientId, redirectUri, buttonContainerId}) => {
    const {authThroughSocialMedia} = useApi();

    const initYandexAuth = useCallback(() => {
        const container = document.getElementById(buttonContainerId);
        if (!container) return;

        container.innerHTML = '';

        window.YaAuthSuggest.init(
            {
                client_id: clientId,
                response_type: 'token',
                redirect_uri: redirectUri,
                state: window.location.href,
            },
            `${window.location.origin}`,
            {
                view: "button",
                parentId: buttonContainerId,
                buttonSize: 'm',
                buttonView: 'iconBg',
                buttonTheme: 'light',
                buttonBorderRadius: "15",
                buttonIcon: 'ya',
                customBgColor: 'rgb(245, 245, 245)',
                customBgHoveredColor: 'rgb(245, 245, 245)',
                customBorderColor: 'rgba(0, 0, 0, 0.05)',
                customBorderWidth: '1',
            }
        )
            .then(({ handler }) => handler())
            .then(data => {
                authThroughSocialMedia('yandexid', {search: ''}, 'post', {access_token: data.access_token})
            })
            .catch(() => console.error(t('common.logIn.error.yandexAuth')));
    }, [clientId, redirectUri, buttonContainerId]);

    useEffect(() => {
        initYandexAuth()
    }, [buttonContainerId]);

    return {initYandexAuth};
};